export const ACCOUNTS_RESET_STATE = 'ACCOUNTS_RESET_STATE';
export const ACCOUNTS_CURRENT_ITEM = 'ACCOUNTS_CURRENT_ITEM';

export const ACCOUNTS_REQUEST_LOADING = 'ACCOUNTS_REQUEST_LOADING';
export const ACCOUNTS_REQUEST_SUCCESS = 'ACCOUNTS_REQUEST_SUCCESS';
export const ACCOUNTS_REQUEST_FAILED = 'ACCOUNTS_REQUEST_FAILED';

export const ACCOUNTS_CURRENT_ACTION = 'ACCOUNTS_CURRENT_ACTION';
export const ACCOUNTS_RESET_ACTION = 'ACCOUNTS_RESET_ACTION';